import { height, padding, width } from "@mui/system";

export const bannerColor = [
  { id: 0, color: "#FF4B42" },
  { id: 1, color: "#00A6FF" },
  { id: 2, color: "#8E5DFF" },
  { id: 3, color: "#44B255" },
  { id: 4, color: "#E3254E" },
  { id: 6, color: "#E5B411" },
];

export const bannerTheme = [
  {
    padding: '1vh 1vh',
    textAlign: 'center',
    borderRadius: '0.5vh',
    zIndex: 1000,
    left: '0',
    right: '0',
    overflow: 'hidden',
    wordWrap: 'break-word',
    background: 'linear-gradient(229.85deg, #00DAFC 15.12%, #0192FD 43.86%, #2959EB 66.92%, #5E0BCD 86.76%)',
    color: "White",
    label:"Curved",
    width:'2vh'
  }, {
    padding: '1vh 1vh',
    textAlign: 'center',
    zIndex: 1000,
    overflow: 'hidden',
    wordWrap: 'break-word',
    left: '0',
    right: '0',
    background: 'linear-gradient(229.85deg, #00DAFC 15.12%, #0192FD 43.86%, #2959EB 66.92%, #5E0BCD 86.76%)',
    color: "White",
    label:"Block",
    width:'2vh'
  }, {
    padding: '1vh 1vh',
    textAlign: 'center',
    zIndex: 1000,
    overflow: 'hidden',
    wordWrap: 'break-word',
    left: '0',
    right: '0',
    borderRadius: '2vh',
    background: 'linear-gradient(229.85deg, #00DAFC 15.12%, #0192FD 43.86%, #2959EB 66.92%, #5E0BCD 86.76%)',
    color: "White",
    label:"Bubble",
    width:'2vh'
  },
  {
    padding:'2vh 0px',
    textAlign: 'center',
    zIndex: 1000,
    overflow: 'hidden',
    wordWrap: 'break-word',
    background: 'linear-gradient(229.85deg, #00DAFC 15.12%, #0192FD 43.86%, #2959EB 66.92%, #5E0BCD 86.76%)',
    clipPath: 'polygon(0% 100%, 90% 100%,100% 0%, 0% 0% )', 
    borderTopRightRadius: '1vh',
    backgroundColor: "#1976d2",
    color: "White",
    label:"Classic",
    width:'2vh',
    height:"1vh"
  }
]

export const commonConstants = {
  NO_AGENDA : 'The agenda has not been provided.',
  No_GUEST_INFO: 'Guest details are currently unavailable.',
  NO_IMP_LINK: 'No important links have been provided for this podcast.',
}

export const API_STATUS = {
  success: '200',
  error: '400',
}


export const SEARCH_TYPE = [
  { "id": 0, type: "Podcaster" },
  { "id": 1, type: "Topic" }
]

export const PAYMENT_TYPE = [
  { "id": 0, type: "Sent Payments" },
  { "id": 1, type: "Received Payments" }
]

export const CONNECTIONS_TYPE = [
  { id: 0, type: 'All Connections' },
  { id: 1, type: 'Favorites' },
  { id: 2, type: 'Requests' }
];

export const buttonStyles = {
  primary: {
    padding: '0.8vh 1.2vh',
    fontSize: '1.6vh',
    borderRadius: '1.2vh',
    letterSpacing: '0.032vh',
    textTransform: 'none',
    background: 'linear-gradient(to right, #472DDB, #0985FB, #00D7FD)',
  },
  forgotPasswordButton: {
    padding: '1.2vh 1.4vh',
    fontSize: '1.8vh',
    borderRadius: '1.2vh',
    textTransform: 'none',
    background: 'linear-gradient(to right, #472DDB, #0985FB, #00D7FD)',
    letterSpacing: '0.032vh',
  },
};

export const passwordValidationStyles = {
  dotBase: {
    width: '0.8vh',
    height: '0.8vh',
    borderRadius: '1.6vh',
    display: 'inline-block',
    transition: 'all 0.3s ease',
    marginRight: '0.8vh',
  },
  dotColors: {
    inactive: 'rgba(168, 168, 168, 0.50)',
    valid: '#00BC42',
    invalid: '#FF4444',
  },
  textStyles: {
    fontSize: '1.6vh',
  },
  progressBar: {
    height: '0.4vh',
    borderRadius: '0.4vh',
    transition: 'background-color 0.3s',
  },
  progressBarColors: {
    active: '#00BC42',
    inactive: 'rgba(255, 255, 255, 0.20)',
  },
};

const createInputFieldStyles = (height = '6.4vh', inputPadding = '1.6vh 2vh') => ({
  '& .MuiOutlinedInput-root': {
    height,
    borderRadius: '1.2vh',
    fontSize: '1.6vh',
    color: '#fff',
    backgroundColor: 'transparent',
    '& fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.5) !important',
      border: '0.15vh solid rgba(255, 255, 255, 0.5) !important',
    },
    '&:hover fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.5) !important',
      border: '0.15vh solid rgba(255, 255, 255, 0.5) !important',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.5) !important',
      border: '0.15vh solid rgba(255, 255, 255, 0.5) !important',
    },
  },
  '& .MuiInputBase-input': {
    padding: `${inputPadding} !important`,
    fontSize: '1.8vh !important',
    color: '#ffffff !important',
    backgroundColor: 'transparent !important',
    '&::placeholder': {
      fontSize: '1.6vh !important',
      opacity: 0.6,
      color: 'rgba(255, 255, 255, 0.5) !important',
    },
  },
  '& .MuiInputBase-input:-webkit-autofill': {
    WebkitBoxShadow: '0 0 0 1000px #000029 inset !important',
    WebkitTextFillColor: '#ffffff !important',
    backgroundColor: '#000029 !important',
    caretColor: '#ffffff !important',
    transition: 'background-color 5000s ease-in-out 0s !important',
  },
  '& .MuiInputBase-input:-webkit-autofill:hover': {
    WebkitBoxShadow: '0 0 0 1000px #000029 inset !important',
    WebkitTextFillColor: '#ffffff !important',
    backgroundColor: '#000029 !important',
  },
  '& .MuiInputBase-input:-webkit-autofill:focus': {
    WebkitBoxShadow: '0 0 0 1000px #000029 inset !important',
    WebkitTextFillColor: '#ffffff !important',
    backgroundColor: '#000029 !important',
  },
});

export const inputFieldStyles = createInputFieldStyles('6.4vh', '1.6vh 2vh');
export const smallInputFieldStyles = createInputFieldStyles('4.8vh', '1.2vh 2vh');
export const forgotPasswordFieldStyles = createInputFieldStyles('5.2vh', '1.6vh 2vh');

// Shared utility: convert HTML to plain text with formatting (bullet points, newlines)
export const htmlToPlainText = (html) => {
  if (!html) return '';
  return html
    .replace(/<\/li>/gi, '\n')
    .replace(/<li[^>]*>/gi, '• ')
    .replace(/<\/p>/gi, '\n\n')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/h[1-6]>/gi, '\n\n')
    .replace(/<\/div>/gi, '\n')
    .replace(/<(?:[^>]{0,10000})>/g, '')
    .replaceAll('&nbsp;', ' ')
    .replaceAll('&amp;', '&')
    .replaceAll('&lt;', '<')
    .replaceAll('&gt;', '>')
    .replace(/\n\n\n+/g, '\n\n')
    .trim();
};

// Shared scrollbar styles for MUI sx
export const scrollbarStyles = {
  '&::-webkit-scrollbar': { width: '0.8vh' },
  '&::-webkit-scrollbar-track': { background: 'transparent', borderRadius: '1.2vh', margin: '0.5vh' },
  '&::-webkit-scrollbar-thumb': { background: '#1976d2', borderRadius: '1.2vh' },
  '&::-webkit-scrollbar-thumb:hover': { background: '#1565c0' },
};

// Shared multiline text field styles for EditShowDetails tabs
export const multilineTextFieldStyles = {
  flex: 1,
  '& .MuiOutlinedInput-root': {
    height: '100%',
    alignItems: 'flex-start',
    padding: '0 !important',
    borderRadius: '1vh',
    color: '#fff',
    backgroundColor: 'transparent',
    '& fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.5) !important',
      border: '0.15vh solid rgba(255, 255, 255, 0.5) !important',
    },
    '&:hover fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.5) !important',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.5) !important',
    },
  },
  '& .MuiInputBase-input': {
    height: '100% !important',
    maxHeight: '100% !important',
    overflow: 'auto !important',
    padding: '1.5vh 1.8vh !important',
    boxSizing: 'border-box',
    fontSize: '1.5vh !important',
    lineHeight: '2.1vh',
    color: '#ffffff !important',
    backgroundColor: 'transparent !important',
    '&::placeholder': {
      fontSize: '1.5vh !important',
      opacity: 0.6,
      color: 'rgba(255, 255, 255, 0.5) !important',
    },
    '&::-webkit-scrollbar': { width: '0.8vh' },
    '&::-webkit-scrollbar-track': { background: 'transparent', borderRadius: '1vh', margin: '0.5vh' },
    '&::-webkit-scrollbar-thumb': { background: '#1976d2', borderRadius: '1vh' },
    '&::-webkit-scrollbar-thumb:hover': { background: '#1565c0' },
  },
};

// Shared small outlined input field styles (ShowName, Tags in EditShowDetails)
export const smallOutlinedInputStyles = {
  '& .MuiOutlinedInput-root': {
    height: '4.5vh',
    borderRadius: '1vh',
    fontSize: '1.4vh',
    color: '#fff',
    backgroundColor: 'transparent',
    '& fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.5) !important',
      border: '0.15vh solid rgba(255, 255, 255, 0.5) !important',
    },
    '&:hover fieldset': { borderColor: 'rgba(255, 255, 255, 0.5) !important' },
    '&.Mui-focused fieldset': { borderColor: 'rgba(255, 255, 255, 0.5) !important' },
  },
  '& .MuiInputBase-input': {
    padding: '1vh 1.5vh !important',
    fontSize: '1.4vh !important',
    color: '#ffffff !important',
    '&::placeholder': {
      fontSize: '1.3vh !important',
      opacity: 0.6,
      color: 'rgba(255, 255, 255, 0.5) !important',
    },
  },
};

// Shared tab FormLabel styles
export const tabFormLabelStyles = {
  color: 'rgba(255, 255, 255, 0.9)',
  fontSize: '1.5vh',
  fontWeight: '400',
  marginBottom: '0.8vh',
  marginLeft: '0.5vh',
  flexShrink: 0,
};

// Shared thumbnail overlay button styles
export const thumbnailOverlayButtonStyles = {
  padding: '0.8vh 1.5vh',
  fontSize: '1.3vh',
  color: '#fff',
  border: 'none',
  borderRadius: '0.8vh',
  cursor: 'pointer',
  background: 'linear-gradient(to right, #472DDB, #0985FB, #00D7FD)',
  letterSpacing: '0.032vh',
  whiteSpace: 'nowrap',
};
